import { useRouteError } from 'react-router'
import { Button } from '../components/button.tsx'
import { Card, CardBody } from '../components/card.tsx'

// Root-level fallback for the data router: React Router renders this in place of the
// entire root route (nav bar included) whenever a loader, action, or render throws
// anywhere in the tree and no closer route defines its own ErrorBoundary/errorElement.
// We deliberately don't branch on the error shape here — see router.tsx for why.
export default function RootErrorBoundary() {
  const error = useRouteError()
  if (import.meta.env.DEV) console.error(error)

  return (
    <div className="flex min-h-dvh items-center justify-center bg-ground-void px-6">
      <Card className="max-w-sm">
        <CardBody className="flex flex-col items-center gap-4 py-12 text-center">
          <h1 className="text-xl font-semibold tracking-tight text-ink-primary">Something went wrong</h1>
          <p className="text-sm text-ink-secondary">
            We hit an unexpected error loading this page. Try heading back to the dashboard.
          </p>
          <Button as="a" href="/" variant="primary">
            Go home
          </Button>
        </CardBody>
      </Card>
    </div>
  )
}
